export default "__VITE_ASSET__CS4RtJf9__"